// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require flux
//= require flux_store

//= require ./_namespace

//= require react_ujs
//= require_tree .
// MAGIC_DESPROCKET_START
require('javascripts/flux/index.js')
require('javascripts/flux_store/index.js')
require('sprocket-compat?this!javascripts/certifications/_namespace.coffee')
require('javascripts/former-gems/react-rails-2.6.0/lib/assets/javascripts/react_ujs.js')
require('sprocket-compat?this!javascripts/certifications/components/certifier_profile_preview.js.jsx')
require('javascripts/certifications/modals/certification_modal.js.jsx')
require('javascripts/certifications/modals/certifier_welcome.js.jsx')
require('javascripts/certifications/modals/editor_welcome_modal_content_wrapper.js.jsx')
require('javascripts/certifications/modals/editor_welcome_modal_intro.js.jsx')
require('sprocket-compat?this!javascripts/certifications/pages/nominations.js.jsx')
require('javascripts/certifications/react/external_link_recommendation.js.jsx')
// MAGIC_DESPROCKET_END
